import { Injectable } from "@angular/core";
import { LogLevel } from "./log-level.model";
import { environment } from "../../../../environments/environment";
import { ApiError } from "../../models/api-error.model";

@Injectable({
  providedIn: "root",
})
export class LogService {
  currentLog: LogLevel;

  debug: (...args: any[]) => void;
  info: (...args: any[]) => void;
  warn: (...args: any[]) => void;
  error: (...args: any[]) => void;

  constructor() {
    this.setLogLevel(environment.logLevel);

    // needs verbose log active in chromse to see debug logs
    this.debug = this.createLogger(LogLevel.DEBUG, console.debug);
    this.info = this.createLogger(LogLevel.INFO, console.log);
    this.warn = this.createLogger(LogLevel.WARN, console.warn);
    this.error = this.createLogger(LogLevel.ERROR, console.error);
  }

  private setLogLevel(level: LogLevel) {
    this.currentLog = level;
  }

  private createLogger(level: LogLevel, logFunction: (...args: any[]) => void) {
    return this.currentLog >= level ? logFunction.bind(console) : () => {};
  }

  shouldLog(error: ApiError): boolean {
    const status = error.status;

    if (status === 0) return true; // Network or CORS error. TODO: Maybe set to false?
    if (status >= 500) return true; // Server errors
    if (status >= 400 && status < 500) return false; // Expected client errors

    return true; // Log anything else unexpected
  }
}
